module.exports = __webpack_public_path__ + "dscout-white.png";